import { getEntityListDynamic } from '@react/shared/helpers/getEntityList';
import { populate } from '@sly/core/constants/populate';
import HubPage from 'sly/hubPage/components/HubPage';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default HubPage;

export async function getServerSideProps({ params }) {
  const { api, store } = createApiClient(apiEndpoints);

  try {
    // TODO deal with non existant guides?
    const [hubpagePromise] = await Promise.all(
      [
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        api.getHubPage.asAction({
          'filters[slug][$eq]': params.hub,
          populate: populate.hubPage,
        }),
      ].map(store.dispatch)
    );
    await getEntityListDynamic(
      hubpagePromise,
      'body.data[0].content',
      api,
      store
    );
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
